import { createTypedOutlet } from "src/router";

import type { EventSyncQuery } from "src/graphql";
import type { DeepNonNullable } from "ts-essentials";

export type ForwardingOutletContext = {
  sync: DeepNonNullable<EventSyncQuery["event_forwarding_syncs_by_pk"]>;
  type: "forwarding";
};

export type WarehouseOutletContext = {
  sync: DeepNonNullable<EventSyncQuery["event_warehouse_syncs_by_pk"]>;
  type: "warehouse";
};

export type EventSyncOutletContext =
  | ForwardingOutletContext
  | WarehouseOutletContext;

const {
  OutletProvider: EventSyncOutlet,
  useContext: useEventSyncOutletContext,
  useOptionalContext: useEventSyncOutletContextIfAvailable,
} = createTypedOutlet<EventSyncOutletContext>("EventSync");

export {
  EventSyncOutlet,
  useEventSyncOutletContext,
  useEventSyncOutletContextIfAvailable,
};

// Type guards
export function isForwardingOutletContext(
  context: EventSyncOutletContext | undefined,
): context is ForwardingOutletContext {
  return context?.type === "forwarding";
}

export function isWarehouseOutletContext(
  context: EventSyncOutletContext | undefined,
): context is WarehouseOutletContext {
  return context?.type === "warehouse";
}
